import { Col, Input, Row, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { weightUnit } from './../../../../../constants';
import Items from './../items';
import RowPackage from './RowPackage';
import './styles.css';

const Option = Select.Option

class Packages extends Component {
    renderRow = () => {
        const { shipment } = this.props
        return this.props.listPackages.map((value, key) => {
            return <RowPackage
                shipment={shipment}
                package={value}
                key={key}
                onChange={this.props.onChange}
                removeRow={this.props.removeRow}
                no={key + 1}
            />
        })
    }

    renderAllItems = () => {
        const { shipment, listPackages } = this.props
        const firstPackage = listPackages[0]
        const allItems = (firstPackage && firstPackage.Items) || []

        // Only render if there are items
        if (allItems.length === 0) {
            return null
        }

        return (
            <tr id="row-package">
                <td />
                <td colSpan={10} id="item-information">
                    <Items
                        shipment={shipment}
                        package={firstPackage}
                        items={allItems}
                    />
                </td>
            </tr>
        )
    }

    renderWeightUnit = () => {
        let renderWeightUnit = []

        weightUnit.push(<Option key value={0}></Option>)
        weightUnit.map((item, key) => {
            renderWeightUnit.push(<Option key value={key + 1}>{item}</Option>)
            return;
        })

        return renderWeightUnit
    }

    render() {
        const { listPackages } = this.props

        return (
            <div id="packages">
                <div className="warp-title">
                    <Col span={4}>
                        <h1 className='title'>Package Information</h1>
                    </Col>
                    <Col span={20}>
                        <Row className="package-info">
                            <Col span={5} className='item'>
                                Length Unit
                                <Input
                                    className="length-unit"
                                    style={{ width: '40%' }}
                                    disabled
                                    value={listPackages[0] ? listPackages[0].LengthUnitCH : null}
                                />
                            </Col>
                            <Col span={5} className='item'>
                                weight unit&nbsp;
                                <Select
                                    className="weight-unit"
                                    style={{ width: '40%' }}
                                    disabled
                                    value={listPackages[0] ? listPackages[0].WeightUnitCH : null}
                                >
                                    {this.renderWeightUnit()}
                                </Select>
                            </Col>
                            <Col span={5} className='item'>
                                no of pkg&nbsp;
                                <Input
                                    className="no-of-pkg"
                                    style={{ width: '40%' }}
                                    disabled
                                    value={listPackages.length}
                                />
                            </Col>
                            <Col span={5} className='item'>
                                total weight&nbsp;
                                <Input
                                    className="total-weight"
                                    style={{ width: '40%' }}
                                    disabled
                                    value={listPackages[0] ? listPackages.reduce((acc, curr) => acc + curr.GrossWeightFL, 0) : null}
                                />
                            </Col>
                        </Row>
                    </Col>
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>NO</th>
                            <th>PACKAGE ID</th>
                            <th>TRACKING. NO</th>
                            <th>PACKAGE GWT</th>
                            <th>STATUS</th>
                            <th>DIMENSIONS (L x W x H)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRow()}
                        {this.renderAllItems()}
                    </tbody>
                </table>
            </div>
        )
    }
}

const mapStateTopProps = state => {
    return {
        listPackages: state.detailShipment.packages,
        shipment: state.detailShipment.shipment
    }
}

export default connect(
    mapStateTopProps
)(Packages)



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/packages/index.js